import styled from 'styled-components';
import { StyledLink } from '../styles/ui';
import { fontSemibold16 } from '../styles/fonts';
export { GroupName } from '../styles/ui';
export const CustomLink = styled(StyledLink) `
  box-sizing: border-box;
  display: flex;
  flex: 0 0 auto;
  width: 100%;
  min-width: 340px;
`;
export const Wrapper = styled.div `
  display: flex;
  flex: 1;
  align-items: center;
  padding: 16px;

  .iconWrapper {
    margin-right: 16px;

    .MuiAvatar-root {
      font-size: 22px;
    }
  }

  .mainWrapper {
    display: flex;
    flex-direction: column;
  }

  .title {
    display: flex;
    align-items: center;
    ${fontSemibold16}
  }
`;
//# sourceMappingURL=styles.js.map